export default {
	CONTAINS: 'Contains',
	TRACES_OF: 'Traces of',
};
